<template>
  <div class="content-wrapper">
    <div class="content">
      <div class="title">
        <p class="title-text">Add Artist</p>
        <p class="subtitle">
          Add a new artist to your account, and create smart links for them.
        </p>
      </div>
      <div class="add-artist-wizard">
        <AddArtistWizard />
      </div>
      <SnackBar />
    </div>
  </div>
</template>

<script>
import SnackBar from "@/components/Custom/SnackBar";
import AddArtistWizard from "@/components/Custom/AddArtistWizard";

export default {
  name: "AddArtist",
  components: {
    AddArtistWizard,
    SnackBar
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    artist() {
      return this.$store.getters.getArtist;
    },
    user() {
      return this.$store.getters.getUser;
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.content-wrapper {
  height: 100%;
  position: relative;
  .content {
    height: 100%;
    background: $bg-type-1;
    display: flex;
    flex-direction: column;
    padding: 36px 60px;
  }
}

.title {
  .title-text {
    margin: 0;
    padding-bottom: 6px;
    font-weight: bold;
    font-size: 30px;
    line-height: 37px;
    color: white;
    mix-blend-mode: normal;
    opacity: 0.9;
  }

  .subtitle {
    margin: 0;
    padding-bottom: 36px;
    /* 16/Regular */
    font-size: 16px;
    line-height: 24px;
    /* Text/type2 */
    color: $text-type-2;
  }
}
.add-artist-wizard {
  flex: 1;
  //padding: 24px;
  //box-shadow: 0 50px 40px rgb(23 18 43 / 30%);
  //border-radius: 10px;
}
</style>
